import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "@redux-saga/core";
import rootSaga from "./rootSaga";
import rootReducer from "./rootReducer";
// import {
//   persistStore,
//   persistReducer,
//   FLUSH,
//   REHYDRATE,
//   PAUSE,
//   PERSIST,
//   PURGE,
//   REGISTER,
//   createTransform,
// } from "redux-persist";
// import storage from "redux-persist/lib/storage";
// import SessionManager from "../services/auth/sessionManager";

// export const store = configureStore({
//   reducer: persistedReducer, //rootReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//       // immutableCheck: true,
//       thunk: true,
//     }).concat([sagaMiddleware]),
//   // preloadedState: initialState,
//   // preloadedState: loadState(),
//   // devTools: process.env.NODE_ENV !== "production",
// });

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: true,
    }).concat([sagaMiddleware]),
});

sagaMiddleware.run(rootSaga);
// export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
